module.exports = __webpack_public_path__ + "img/otf1.da90c5a9.png";